
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    SIM_INFO_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { simInfoResult } from 'Redux/actions';


function* getSimDetails({ payload }) {
    try {

        const QUERY = `
            query getSimDetails ($iccid: String!) {
                result: getSimDetails (iccid: $iccid)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                iccid: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if(data?.result){
            yield put(simInfoResult(data?.result))
        }else{
            yield put(simInfoResult({ error: true }))
        }

    } catch (exc) {
        yield put(simInfoResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/simInfoTab/redux/saga",
            "getSimDetails",
        )
    }
}


function* watchMethods() {
    yield takeEvery(SIM_INFO_REQUEST, getSimDetails);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}